import React from "react";

interface ConsentSectionProps {
  id: string;
  title: string;
  description?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * One card on the Consent Banner tab (Regions, Appearance, ...). Rows inside draw their own top divider; the first
 * row's is dropped so it sits flush under the header.
 */
export const ConsentSection = ({ id, title, description, children }: ConsentSectionProps) => (
  <section
    id={id}
    aria-labelledby={`${id}-title`}
    className="scroll-mt-[calc(var(--consent-sticky-top,0px)_+_var(--consent-header-height,112px)_+_24px)] rounded-xl border border-solid border-neutral-200 bg-white shadow-[0px_1px_2px_0px_#1018280D]"
  >
    <header className="rounded-t-xl border-0 border-b border-solid border-neutral-200 bg-neutral-0 px-[24px] py-[16px]">
      <h3
        id={`${id}-title`}
        className="m-0 text-[16px] font-semibold leading-[24px] text-neutral-900"
      >
        {title}
      </h3>
      {description && (
        <p className="mb-0 mt-[2px] text-[14px] leading-[20px] text-neutral-600">{description}</p>
      )}
    </header>
    <div className="px-[24px] [&>*:first-child]:border-t-0">{children}</div>
  </section>
);

/** Groups related rows inside a section, e.g. everything about the opt-in banner. */
export const ConsentGroupHeader = ({ title, usedIn }: { title: string; usedIn?: string }) => (
  <div className="flex flex-wrap items-baseline gap-x-[12px] gap-y-[4px] border-0 border-t border-solid border-neutral-200 pt-[20px] [&+*]:border-t-0 [&+*]:pt-[12px]">
    <h4 className="m-0 text-[12px] font-semibold uppercase leading-[16px] tracking-[0.06em] text-neutral-800">
      {title}
    </h4>
    {usedIn && <span className="text-[12px] leading-[16px] text-neutral-600">{usedIn}</span>}
  </div>
);
